import { render, staticRenderFns } from "./SendTestMail.vue?vue&type=template&id=1bbeb264&scoped=true&"
import script from "./SendTestMail.vue?vue&type=script&lang=js&"
export * from "./SendTestMail.vue?vue&type=script&lang=js&"
import style0 from "./SendTestMail.vue?vue&type=style&index=0&id=1bbeb264&lang=scss&scoped=true&"
import style1 from "./SendTestMail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbeb264",
  null
  
)

export default component.exports